import Cookies from 'js-cookie';

// Cookie configuration
const COOKIE_CONFIG = {
  expires: 7, // 7 days
  secure: process.env.NODE_ENV === 'production',
  sameSite: 'strict'
};

// Token management functions
export const setTokenCookie = (token) => {
  if (token) {
    Cookies.set('token', token, COOKIE_CONFIG);
  }
};

export const getTokenCookie = () => {
  return Cookies.get('token');
};

export const removeTokenCookie = () => {
  Cookies.remove('token');
};

// Other user data cookie functions
export const setUserCookie = (key, value) => {
  if (value !== undefined && value !== null) {
    Cookies.set(key, value, COOKIE_CONFIG);
  }
};

export const getUserCookie = (key) => {
  return Cookies.get(key);
};

export const removeUserCookie = (key) => {
  Cookies.remove(key);
};

// Helper function to get token from cookies only
export const getToken = () => {
  return getTokenCookie();
};

// Helper function to set token in cookies only
export const setToken = (token) => {
  setTokenCookie(token);
};

// Token validation functions
export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    // Decode JWT token (without verification)
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    
    // Check if token has expired (with 5-minute buffer)
    return payload.exp < currentTime - 300;
  } catch (error) {
    // If token is malformed, consider it expired
    return true;
  }
};

export const isUserAuthenticated = () => {
  const token = getToken();
  return token && !isTokenExpired(token);
};

// Clear all authentication data
export const clearAuthData = () => {
  removeTokenCookie();
  // Clear all user-related cookies
  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const [name] = cookie.trim().split('=');
    if (name && (name.includes('user') || name.includes('auth') || name.includes('token'))) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
  
  // Clear localStorage
  const authKeys = ['logged_user_id', 'chef_id', 'user_email', 'user_name', 'token'];
  authKeys.forEach(key => localStorage.removeItem(key));
};
